export default class FasciaPopup
{
	constructor()
	{
		let _this = this;
	}

	static openPopup(node)
	{
		let _this = this;
		this.node = node;

		$.fancybox.open({
			src: '#' + this.node.id,
			type: 'inline',
			afterClose: function ()
			{
				_this.setHideCookie();
			}
		});

		FasciaPopup.addListeners();
	}

	static addListeners()
	{
		let _this = this;

		this.node.querySelector('a').addEventListener('click', function ()
		{
			FasciaPopup.setHideCookie();
		})
	}

	static setHideCookie()
	{
		var expires = (new Date(Date.now() + 86400 * 356)).toUTCString();
		document.cookie = this.node.getAttribute("data-fascia-popup") + "=hide; expires=" + expires + "; path=/";
	}

	checkTimer()
	{
		var t = FasciaPopup.getCookie("timer");
		if (t == null)
		{
			var dt = new Date();
			var time = dt.getFullYear() + ":" + dt.getMonth() + ":" + dt.getDate() + ":" + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
			document.cookie = "timer=" + time + "; expires=0; path=/";
		}
		else
		{
			var splitted = t.split(":");
			var startDate = new Date(splitted[0], splitted[1], splitted[2], splitted[3], splitted[4], splitted[5]);
			var endDate = new Date();
			var seconds = parseInt((endDate.getTime() - startDate.getTime()) / 1000);
			try
			{
				console.log(seconds + '/' + FasciaPopup.openAfterSeconds);
			}
			catch (e) { }
			if (seconds > FasciaPopup.openAfterSeconds && !FasciaPopup.opened)
			{
				FasciaPopup.opened = true;
				clearInterval(FasciaPopup.interval);
				FasciaPopup.openPopup(document.querySelector("[data-fascia-popup]"));
			}				
		}
	}

	static getCookie(name)
	{
		var a = document.cookie.split('; ');
		var b = a.find(row => row.startsWith(name));
		if (b != null)
			return b.split('=')[1];
		return null;
	}

	static init()
	{
		FasciaPopup.opened = false;
		FasciaPopup.openAfterSeconds = 60;
		let popupNode = document.querySelector("[data-fascia-popup]");
		if (popupNode)
		{
			var a = new FasciaPopup();
			FasciaPopup.interval = setInterval(a.checkTimer, 1000);
		}
	}
}
